import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ConfigService } from './../../../../formbird-services/src/lib/services/config/config.service';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import {SearchService} from '../../../../formbird-services/src/lib/services/search/search.service';
import {NotificationService} from '../../../../formbird-services/src/lib/services/notification/notification.service';
import * as $ from 'jquery';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from '../../../../formbird-mapping/src/lib/http.service';
import { SclAssetLayersService } from '../../../../formbird-mapping/src/lib/scl-asset-layers.service';
import { SclMapConstantService } from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import { SclMapViewsService } from '../../../../formbird-mapping/src/lib/scl-map-views.service';
import { SclMappingFunctionsService } from '../../../../formbird-mapping/src/lib/scl-mapping-functions.service';
import { SclUtilMapService } from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { StreetAddressComponentDefinition } from './street-address.component.definition';
import {isEqual, cloneDeep, find} from 'lodash';
import { AddressDetails } from '../../../../formbird-mapping/src/lib/AddressDetails';
import {sclHandlebars} from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import { MapLibraryName, MapComponentName, MapSelectAssetType, MapDrawType, FEATURE_TYPE } from '../../../../formbird-mapping/src/lib/map-library';

@Component({
  templateUrl: './street-address.component.html',
  styleUrls: [
    './street-address.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreetAddressComponent extends AbstractComponent<StreetAddressComponentDefinition> implements OnInit, AfterViewInit, OnChanges {


  @Input() responsiveLayouts: string;

  @ViewChild('info', {static: false}) divInfo: ElementRef;
  @ViewChild('info1', {static: false}) divInfo1: ElementRef;
  @ViewChild('infoCluster', {static: false}) divInfoCluster: ElementRef;
  @ViewChild('tooltipInfo', { static: false }) tooltipInfo: ElementRef;
  @ViewChild('mapWrapper', {static: false}) mapWrapper: ElementRef;

  // service
  loggedInUserService: any;

  //
  mapFunc;
  autoCompleteBox;
  isComponentReady = false;
  mapGeo;
  fullWidthClass = 'streetAddress-fullwidth';  // removed class col-xs-12

  //
  disableSave;
  keyName;
  view;
  marker;
  map;
  isEditable;
  disableMouseWheel = false;
  results = {};
  current = null;
  timeDelay = 1000;
  countryCode;
  timeOutDelay = 1000;
  apiKey;
  geocodeURL = 'https://www.geocode.farm/v3/json/reverse/';
  isGoogleGeocodeService = false;
  geocodeSearchService = [];
  positionMandatory;
  mapParameters;
  debounce = SclMapConstantService.DEFAULT_SEARCH_DELAY;
  searchMinLength = SclMapConstantService.DEFAULT_SEARCH_LENGTH;
  fullWidth = true;
  zoomFloor;
  centerOnReverse = false; // 14288
  searchZoom = false; // 14479#0053120 ( just use for comp-dev )
  layers;
  mapLibName = MapLibraryName.OPEN_LAYER;
  googleKey = null;
  defaultLat;
  defaultLon;
  defaultZoom;
  controls = [];
  layerIds = [];
  //
  isLoadSavedDocument;
  watchDocument: BehaviorSubject<any>;
  documentOldValue;
  featureCollections;
  geoJsonField = '';
  isMapReady; // 14781#c55330
  loadAssetCounter = 0;
  layersRedraw = false;
  intervalToolTipSetup = null; countIntervalTooltipSetup = 0; hasCustomControl = false; // 15336#c59379
  isPopupClusterOpen = false; isClusterPopupScroll; clusterList: any = []; clusterMarkersClicked = []; allowSelectAsset; // 15251
  toolTipTimeout = undefined;
  tooltipsTimeout = null;
  focusPopup;
  currentPopover = null;
  tooltipText;
  toolTipZIndex = 100;
  disablePopupOkButton;
  postList: any = [];
  isRadioPopupScroll;
  streetDataComp;
  hasOnFieldValueChange = false;
  streetDataInit;
  searchClientService: any;
  initialAssetLoading = true; // 20117
  disableAddress = false;
  hasMapWheelScroll = false;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    public httpService: HttpService,
    public cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    private sclUtilMapService: SclUtilMapService,
    private sclMapViews: SclMapViewsService,
    private httpClient: HttpClient,
    private notificationService: NotificationService,
    private configService: ConfigService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService');

    this.mapFunc = new SclMappingFunctionsService(httpClient, cdRef, notificationService);
    this.mapFunc.createFeature = this.createFeature.bind(this);
    this.mapFunc.updateAddress = this.updateAddress.bind(this);
    this.mapFunc.updateMap = this.updateMap.bind(this);
    this.mapFunc.currentLocationCheckBoxOnClick = this.currentLocationCheckBoxOnClick.bind(this);
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.mapFunc.unregisterMapWrapperChange(this.mapWrapper);
  }

  ngOnInit() {

    if (this.configService.clientConfig().searchDelay) {
      this.debounce = this.configService.clientConfig().searchDelay;
    }
    this.mapFunc.tooltipHandleBarObjects = [];
    
    if (this.mapLibName === MapLibraryName.GOOGLE) {
      this.mapFunc.maxZoomAsset = 20;
      this.mapFunc.minZoomAsset = 15;
    } else if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      this.mapFunc.maxZoomAsset = 16;
      this.mapFunc.minZoomAsset = 9;
    }

    if (this.componentDefinition) {
      if (this.componentDefinition.maxZoom) { this.mapFunc.maxZoomAsset = this.componentDefinition.maxZoom; }
      if (this.componentDefinition.minZoom) { this.mapFunc.minZoomAsset = this.componentDefinition.minZoom; }

      this.componentSetupService.setupStandardProperties(this);
      this.fullWidthClass = ( this.componentDefinition.fullWidth
        ? 'streetAddress-fullwidth' : 'streetAddress-not-fullwidth' ); // removed class
      this.disableSave = false;
      if (!(typeof this.componentDefinition.disableSave === 'undefined' || this.componentDefinition.disableSave === null)) {
        this.disableSave = this.componentDefinition.disableSave;
      }
      this.fieldName = this.componentDefinition.name;

      if (this.componentDefinition.searchDelay) {
        this.debounce = this.componentDefinition.searchDelay;
      }
      if (this.componentDefinition.searchMinLength) {
        this.searchMinLength = this.componentDefinition.searchMinLength;
      }
      if (this.componentDefinition.disableMouseWheel) {this.disableMouseWheel = this.componentDefinition.disableMouseWheel; }
      if (this.componentDefinition.countryCode) {this.countryCode = this.componentDefinition.countryCode; }
      if (this.componentDefinition.geocodeSearchService) { this.geocodeSearchService = this.componentDefinition.geocodeSearchService; }
      if (this.componentDefinition.disableAddress) {
        this.disableAddress = this.componentDefinition.disableAddress;
      }
      if (this.componentDefinition.mapParameters) {
        this.mapParameters = this.componentDefinition.mapParameters;
        if (this.mapParameters.EPSG) { this.mapFunc.EPSG = this.mapParameters.EPSG; }
        if (this.mapParameters.searchZoom) {
          this.searchZoom = this.mapParameters.searchZoom;
        }
      }
      if (this.componentDefinition.positionMandatory) { this.positionMandatory = this.componentDefinition.positionMandatory; }
      // if(!this.componentDefinition.mandatoryFields) this.componentDefinition.mandatoryFields = ["suburb"];
      if ( typeof this.componentDefinition.mandatoryValuesArray === 'undefined'
       || this.componentDefinition.mandatoryValuesArray === null  ||
          this.componentDefinition.mandatoryValuesArray === 0 ) {
          this.componentDefinition.mandatoryValuesArray = [
              {
                name: 'Please enter or select a valid address that contains a Street Name',
                jsonPathQuery: '$..features[?(@.properties.street)]'
              },
              {
                name: 'Please enter or select a valid address that contains a Suburb',
                jsonPathQuery: '$..features[?(@.properties.suburb)]'
              }
          ];
      }
      if (typeof this.componentDefinition.fullWidth !== undefined
        && this.componentDefinition.fullWidth !== null) { this.fullWidth = this.componentDefinition.fullWidth; }
      if (this.componentDefinition.zoomFloor) { this.zoomFloor = this.componentDefinition.zoomFloor; }
      if (this.componentDefinition.centerOnReverse) { this.centerOnReverse = this.componentDefinition.centerOnReverse; }

      // flexible height of map
      this.mapFunc.mapHeight = '180';
      let height;
      if (this.componentDefinition.heightNum && this.componentDefinition.heightNum > 0 && !isNaN(this.componentDefinition.heightNum)) {
          height = 180 * this.componentDefinition.heightNum;
          const docHeight = document.body.scrollHeight;
          if (height > (docHeight - 180)) {
              height = docHeight - 180;
          }
          // targetMap.style.height = '' + height + 'px';
          this.mapFunc.mapHeight = height;
      } else {
          height = 180;
          // targetMap.style.height = '180px';
          this.mapFunc.mapHeight = '180';
      }// 13916

      if (this.componentDefinition.layers) {
        let idx = 0;
        for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
          idx++;
          // 1. logic for options updateWatchFieldsLayer independence with logic 2. , put in this loop for performance
          if (typeof this.componentDefinition.layers[i].updateWatchFields !== 'undefined') {
            for (let j = 0; j < this.componentDefinition.layers[i].updateWatchFields.length; j++) {
              const key = this.componentDefinition.layers[i].updateWatchFields[j];
              if (key in this.mapFunc.updateWatchFieldsLayer) {
                if (this.mapFunc.updateWatchFieldsLayer[key].indexOf(idx) > -1 ) { continue; }

                this.mapFunc.updateWatchFieldsLayer[key].push(idx);

              } else {
                this.mapFunc.updateWatchFieldsLayer[key] = [idx];
              }
            }
            this.mapFunc.hasUpdateWatchField = true;
          }

          // 2. another logic for layerAssets independence with logic 1.
          let isHeatMap = false;
          if (this.componentDefinition.layers[i].type && this.componentDefinition.layers[i].type === 'heatmap') {
            isHeatMap = true;
          }
          this.mapFunc.layerAssets.push({query: this.componentDefinition.layers[i].filter + '_layer_' + idx, i: idx
            , isHeatMap, layer: this.componentDefinition.layers[i], isFilter: false
            , currentFilter: this.componentDefinition.layers[i].filter, features: []});

        }
      }
      if (this.componentDefinition.geoJsonField) { this.geoJsonField = this.componentDefinition.geoJsonField; }
      if (this.componentDefinition.filter) {
        const layerIndex = (this.componentDefinition.layers ? this.componentDefinition.layers.length + 1 : 1);
        const layerFilter = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.geoJsonField);
        this.mapFunc.layerAssets.push({query: this.componentDefinition.filter + '_filter_' + layerIndex, i: layerIndex
          , isHeatMap: false, layer: layerFilter, isFilter: true
          , currentFilter: this.componentDefinition.filter, features: [] });
      }
      if (this.componentDefinition.showTiming) {
        this.mapFunc.showTiming = this.componentDefinition.showTiming;
      }
      if (!(typeof this.componentDefinition.tooltipsTimeout === 'undefined' ||
      this.componentDefinition.tooltipsTimeout === null)) {
        this.tooltipsTimeout = this.componentDefinition.tooltipsTimeout;
      }

      if ( !(typeof this.componentDefinition.initialAssetLoading === 'undefined' ||
      this.componentDefinition.initialAssetLoading === null) ) {
        this.initialAssetLoading = this.componentDefinition.initialAssetLoading;
      }

      if (this.componentDefinition.queryPageSize) {
        this.mapFunc.pageSize = this.componentDefinition.queryPageSize; // 14603 : override assetField.maxVectorItems
      }
      if (!(typeof this.componentDefinition.disableHandlebars === 'undefined' ||
        this.componentDefinition.disableHandlebars === null)) {
          this.mapFunc.disableHandlebars = this.componentDefinition.disableHandlebars;
      }// 15250
      // test re-draw layer
      if (this.componentDefinition.layersRedraw) { this.layersRedraw = this.componentDefinition.layersRedraw; }
    }

    sclHandlebars.initHandlebars(this.componentDefinition.handlebarsHelpers);
    this.mapFunc.addressId = this.template.documentId;
    this.mapFunc.contextParams = {
      doc : this.document,
      account: this.loggedInUserService.user.account,
      tpl: this.template,
      tplItem: this.componentDefinition
    };

    this.keyName = this.fieldName + this.template.documentId;
    this.setupChangeDetection();

    const panelSub = this.broadcastService.on('panel-comp-def-updated').subscribe((data) => {
      console.log('On panel component def updated.......', data);
      if (data?.startKey < this.key && this.key < data?.endKey) {
        if (this.componentDefinition.visible !== false) {
          if (this.mapLibName === MapLibraryName.OPEN_LAYER && this.mapFunc) {
            this.mapFunc.showMap();
            console.log('Show Map called.');
          }
        }
      }
    });
    this.subs.add(panelSub);

    const docSub = this.changedDocumentService.watchDocument(this.document.documentId).subscribe(doc => {

      this.document = doc;
      this.mapFunc.contextParams.doc = doc;

    });
    this.subs.add(docSub);


    this.watchDocument = new BehaviorSubject<any>(this.featureCollections);
    const featureSub = this.watchDocument.subscribe(obj => {
        this.watchDoc(obj);
      });
    this.subs.add(featureSub);

  } // end ngOnInit

  onFieldValueChanged(fieldValue) {
    if (isEqual(this.fieldValue, fieldValue)) {
      console.log('watch document, OLD = NEW');
      return;
    }
    this.fieldValue = cloneDeep(fieldValue);
    console.log('****** watch document, fieldValue = ' + fieldValue);
    this.watchDoc(this.fieldValue);
    if (!fieldValue) {
      this.removeStreet();
    }
  }
  onComponentDefChanged(componentDefinition) {

    super.onComponentDefChanged(componentDefinition);

    if (((typeof componentDefinition.visible === 'undefined') || componentDefinition.visible === null)
      || componentDefinition.visible) {
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        this.mapFunc.showMap();
      }
    }

    const obj = this.sclUtilMapService.checkDisableAddressEntry(this.componentDefinition, this.geocodeSearchService);
    this.mapFunc.isDisableAddressEntry = obj.disableAddressEntry;

    this.mapFunc.setActivateButtonLookupAddress();

    this.mapFunc?.switchMapView(this.componentDefinition?.mapParameters?.showMapView, this.keyName);
    
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.initMap();

    this.mapFunc.registerMapWrapperChange(this.mapWrapper, this.onMoveEnd.bind(this));

  } // end ngAfterViewInit

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }

  setupChangeDetection() {
    super.setupChangeDetection();
  }


  initMap() {
    this.mapFunc.divInfo = this.divInfo;
    this.mapFunc.divInfo1 = this.divInfo1;
    this.mapFunc.divInfoCluster = this.divInfoCluster;

    if (this.mapParameters) {
      this.defaultLat = this.mapParameters.defaultLat;
      this.defaultLon = this.mapParameters.defaultLon;
      this.defaultZoom = this.mapParameters.defaultZoom;

      if (this.mapParameters.mapViews) {
        for (let i = 0; i < this.mapParameters.mapViews.length; i++) {
          if (this.mapParameters.mapViews[i].serverType === MapLibraryName.GOOGLE) {
            this.mapLibName = MapLibraryName.GOOGLE;
            this.googleKey = (typeof this.mapParameters.mapViews[i].apiKey === 'undefined'
              || this.mapParameters.mapViews[i].apiKey === null) ? null : this.mapParameters.mapViews[i].apiKey;
            if (this.googleKey == null) { console.error('Google map key is null'); }
            break;
          }
        }
      } else {
        this.mapParameters.mapViews = SclMapConstantService.DEFAULT_MAP_PARAMETERS.mapViews;
      }
    } else { this.mapParameters = SclMapConstantService.DEFAULT_MAP_PARAMETERS; }


    const streetWrapper = document.getElementById(this.keyName + 'StreetWrapper');
    const mapWrapper = document.getElementById(this.keyName + 'MapWrapper');
    if (this.fullWidth === false) {
      if (streetWrapper != null) {
        streetWrapper.style.width = '100%';
      }
      if (mapWrapper != null) {
        mapWrapper.style.width = '100%';
      }
    }
    const mapId = this.keyName + 'gblMap';
    const targetMap = document.getElementById(mapId); // target
    const divWrapper = document.getElementById(this.keyName + 'MapWrapper');
    this.mapFunc.targetMapElement = targetMap;
    const self = this;
    // init map
    this.mapFunc.initLib(this.mapFunc, this.mapLibName , {googleKey: this.googleKey}
      , async (mapObj) => {
      console.log('****************** init map done ******************* ');
      this.isComponentReady = true;
      this.cdRef.detectChanges(); // to make isParentReady of geo-aut-complete updated
      this.mapFunc.mapObj = mapObj;
      this.mapFunc.multiLayers(this.mapParameters); // add multiple map views

      // add button pencil
      const addSelectAction = (element) => {
        const checkbox = this.sclMapViews.createCheckbox(document, this.keyName + 'Select');
        checkbox.onclick = () => {
          this.isEditable = !this.isEditable;
        };
        element.appendChild(checkbox);

        const iSpan = document.createElement('i');
        iSpan.setAttribute('class', 'material-icons');
        iSpan.innerHTML = 'mode_edit';

        const label =  this.sclMapViews.createLabel(document, this.keyName + 'Select', null);
        label.setAttribute('class', 'control-pencil');
        label.appendChild(iSpan);
        element.appendChild(label);

        this.mapFunc.pencilElements.push(checkbox);
        this.mapFunc.pencilElements.push(label);
      };

      const ActionControl = function(ctrlOptions) {
        const options = ctrlOptions || {};
        const element = document.createElement('div');


        const controlElement = document.createElement('div');
        if (self.mapLibName) {
            controlElement.className = 'gg-control check-group select-action ol-control custom-control';
        } else { controlElement.className = 'check-group select-action ol-control custom-control'; }

        addSelectAction(controlElement);
        self.mapFunc.addCurrentLocationCheckbox(self.keyName, controlElement);

        // element.appendChild(locationElement);
        element.appendChild(controlElement);


        self.mapFunc.addMapViewControl(element, self.keyName, self.layerIds);

        self.mapFunc.mapObj.layersRedraw = this.layersRedraw;
        self.mapFunc.mapObj.layersRedrawCount = ( (self.componentDefinition.layers) ?
        self.componentDefinition.layers.length : 0 ) + ( (self.componentDefinition.filter) ? 1 : 0 );
        self.mapFunc.mapObj.addControl(this, element, options);
        self.mapFunc.mapObj.elementCtrl = controlElement;

      };
      this.mapFunc.mapObj.setupControl(ActionControl);
      this.controls.push(new ActionControl({}));

      await this.mapFunc.setupMap(this.mapFunc, {configService: this.configService
        , target: this.mapFunc.targetMapElement, disableMouseWheel : this.disableMouseWheel
        , divWrapper, defaultLon: this.defaultLon, defaultLat: this.defaultLat
        , defaultZoom: this.defaultZoom, EPSG: this.mapFunc.EPSG
        , minResolution: this.mapParameters.minResolution, maxResolution: this.mapParameters.maxResolution
        , layerAssets : this.mapFunc.layerAssets
        , controls: this.controls, style: MapComponentName.STREET_ADDRESS
        , mapId: mapId
        , setDirty : this.setDocDirty.bind(this), zoomFloor: this.zoomFloor
        , componentDefinition : this.componentDefinition // 11618#c55242 : hasn't needed for angularJS version yet
        , intervalToolTipSetup: this.intervalToolTipSetup
        , countIntervalTooltipSetup: this.countIntervalTooltipSetup
        , hasCustomControl: this.hasCustomControl
        , setupTooltipUI: this.mapFunc.setupTooltipUI.bind(this.mapFunc)
        , toolTipOnFeatureHover: (e) => {
          this.mapFunc.tooltipOnFeatureHover(e, this.mapLibName);
        }
        , tooltipInfo: this.tooltipInfo
        , cdRef: this.cdRef
        , watcherFunction: (doc) => {
          // 16772#0068539
          if (!isEqual(this.document, doc)) {
            this.document = doc;
            this.mapFunc.contextParams.doc = this.document;
          } else {
            console.log('happenning watch document but new Value = old Value');
          }
        }
        , onMapWheelScroll: this.onMapWheelScroll.bind(this)
      }, this.keyName);
      this.toolTipZIndex = this.mapFunc.mapObj.layerIndexTooltips;


      // load asset
      const allowLoadAsset = (!this.mapFunc.disableProcessingOnLoad && this.initialAssetLoading) ? true : false;

      if (this.isMapReady == null) {
        this.isMapReady = setInterval(() => {
          if (this.mapFunc.mapObj.isMapReady) {
            this.mapFunc.resetupTooltipUI();
            clearInterval(this.isMapReady);
            this.isMapReady = null; // reset
            if (allowLoadAsset) {
              this.loadAsset('mapReady', true);
            }
            this.mapFunc.mapObj.mapMoveEnd(this.onMoveEnd.bind(this));
          }
        }, 200);
      }


      // init mapGeo
      this.autoCompleteBox = document.getElementById(this.keyName + 'GeoAutoComplete');

      this.mapFunc.mapObj.mapClickEvent(this.onMapClickEvent.bind(this)); // end map click event

      // load saved address
      if (!this.fieldValue) {
        if (this.streetDataComp) {
          this.streetDataComp.streetData[this.keyName] = new AddressDetails();
        }
      } else if (this.fieldValue.features) {
        this.featureCollections = cloneDeep(this.fieldValue);
        this.resetPostionMandatory();
      }
      this.setPositionForAsset();
      this.setInteract();
      this.mapFunc.actionAfterMapReady(this.mapFunc.setFieldActivation(this.mapFunc.targetMapElement, this.disabled, this.layerIds));
      this.mapFunc.mapObj.mapPointerMoveEvent( (evt) => {
        if (evt.dragging) {
          this.mapFunc.hasMapDragging = evt.dragging;
          if (this.mapFunc?.hasMapDragging) {
            this.mapFunc.subLabelTiming = "On-map-pointer-move-end";
          }
          return;
        }

        this.mapFunc.lastEvt = evt;
        if (!this.mapFunc.mouseStopInterval && (!this.mapFunc.focusPopup || !this.mapFunc.currentPopover)) {
          this.mapFunc.mouseStopInterval = setInterval(() => {
            this.mapFunc.hasMouseStopped(evt);
          }, 450);

        }
      });

    }, this.changedDocumentService, this.subs, this.document); // finish init map

    $(this.mapFunc.targetMapElement).on('mouseleave', this.onMapMouseLeave.bind(this));

  } // end initMap function
  onMapMouseLeave() {
    if (this.mapFunc.isPopoverOpen) {
      this.mapFunc.dismissPopover();
    }
  }

  onMoveEnd(evt) {
    if (this.isMapReady == null) {
      this.isMapReady = setInterval( this.mapReady.bind(this), 200);
    }
  }
  onMapWheelScroll(evt) {
    this.hasMapWheelScroll = true;
    this.mapFunc.subLabelTiming = "On-Map-Wheel-Scroll";
  }
  mapReady() {
    if (this.mapFunc.mapObj.isMapReady) {
      this.mapFunc.resetupTooltipUI();
      clearInterval(this.isMapReady);
      this.isMapReady = null; // reset
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        if (this.mapFunc?.hasMapDragging == true) {
          this.mapFunc.hasMapDragging = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else if (this.mapFunc.mapObj.hasClickButtonZoom == true) {
          this.mapFunc.mapObj.hasClickButtonZoom = false; // reset
          this.loadAsset('click zoom button & mapMoveEnd', false);
        } else if (this.mapFunc.hasResize === true) {
          this.mapFunc.hasResize = false; // reset
          this.loadAsset('has resize window & mapMoveEnd', false);
        } else if(this.mapFunc.hasMapWrapperResize) {
          this.mapFunc.hasMapWrapperResize = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else if (this.hasMapWheelScroll) {
          this.hasMapWheelScroll = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else {
          console.log(`**** CASE : has "map move end" event but don\'t load asset`);
        }
      } else {
        this.loadAsset('mapMoveEnd', false);
      }
      this.resetMapAction();
    }
  }
  resetMapAction() {
    this.mapFunc.subLabelTiming = 'Unknow-Source'; // reset
    this.mapFunc.hasMapDragging = false;
    this.mapFunc.mapObj.hasClickButtonZoom = false;
    this.mapFunc.hasResize = false;
    this.hasMapWheelScroll = false;
  }

  // begin logic for geo-auto-complete
  initGeoAutoComplete(e) {
    this.mapFunc.geoAutoComplete = e.geoAutoComplete;
    this.mapGeo = this.mapFunc.geoAutoComplete.mapGeo;
    this.mapFunc.isDisableAddressEntry = this.mapFunc.geoAutoComplete.isDisableAddressEntry;
  }
  // end logic for geo-auto-complete

  addHeader() {
    if (this.featureCollections == null) {
      const header = {
          type : 'FeatureCollection',
          features: []
      };
      this.featureCollections = header;
    }
  }
  updateValue() {
    this.featureCollections.features = [];
    if (this.streetDataComp && this.streetDataComp.streetData && this.streetDataComp.streetData[this.keyName]) {
        if ( !isEqual(this.streetDataComp.streetData[this.keyName], SclMapConstantService.STREET)) {
            const st = cloneDeep(this.streetDataComp.streetData[this.keyName]);
            this.sclUtilMapService.streetDataRemoveEmpty(st);
            this.featureCollections.features.push( st );
        }
    }
  }

  setDocDirty() {
    if (this.disableSave) { return; }
    this.addHeader();
    this.updateValue();
  }
  updateAddress(lat, lng) {
    this.addHeader();
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    let st = this.streetDataComp?.streetData[this.keyName];
    if (!st) {
      st = new AddressDetails();
    }
    if (!st.geometry || !st.geometry.coordinates) {
      st.geometry = {
        coordinates: [],
        type: MapDrawType.POINT
      };
    }
    st.geometry.coordinates[0] = lng;
    st.geometry.coordinates[1] = lat;
    if (this.streetDataComp) {
      this.streetDataComp.streetDataStr = JSON.stringify(st);
    }
    this.updateMap(lat, lng, true, true);

    if (this.mapGeo) { // use geocodeSearchService
      this.mapGeo.reverse([lng, lat]
        , (streetData) => {
          if (streetData) {
            st = streetData;
          }
          if (this.streetDataComp) {
            this.streetDataComp.streetDataStr = JSON.stringify(st);
          }
        }
        , (err) => {
          console.log('error = ' + err);
        });
    } else { // use default geo api
      const link = this.sclUtilMapService.getGeocodeCoordinate(this.geocodeURL, lat, lng, this.componentDefinition, this.apiKey);
      this.httpClient.get(link).subscribe(res => {
          const data = (res as any);
          if (data && data.geocoding_results.STATUS.status === 'SUCCESS') {
            const suggestions = data.geocoding_results.RESULTS[0];
            const address = suggestions.ADDRESS;
            st.properties.streetNo = address.street_number;
            st.properties.street = address.street_name;
            st.properties.suburb = address.locality;
            st.properties.postcode = address.postal_code;
            st.properties.country = address.country;
            st.properties.state = address.admin_1;
            st.geometry.coordinates[0] = lng;
            st.geometry.coordinates[1] = lat;
            if (this.streetDataComp) {
              this.streetDataComp.streetDataStr = JSON.stringify(st);
            }
          }
        },
        error => {
          console.log('Error : ' + error);
          this.notificationService.warning('GeoCodeFarm Address Reverse is not functioning. Please contact your System Administrator');
        });
    }
  }
  updateMap(lat, long, isMapClick, isZoomToLocation) {
    this.mapFunc.mapObj.updateLocation(lat, long, this.mapFunc.addressId, SclMapConstantService.MAP_MARKER
      , 'address', this.mapFunc.addressId, isMapClick);
    if (isZoomToLocation) {this.mapFunc.mapObj.zoomToLocation(lat, long); }
  }
  currentLocationCheckBoxOnClick(locationFn) {
    if (this.disabled) { return; }

    locationFn();
  }

  // draw selected asset on map when save document
  setPositionForAsset() {
    if (this.featureCollections && this.featureCollections.features) {
      this.isLoadSavedDocument = true;
      if (this.streetDataComp) {
        this.streetDataComp.streetData[this.keyName] = this.featureCollections.features[0];
        this.sclUtilMapService.checkStreetGeometryComponent(this.streetDataComp, this.keyName);

        if (this.streetDataComp.streetData && this.streetDataComp.streetData[this.keyName]
          && this.streetDataComp.streetData[this.keyName].geometry) {
         if (this.streetDataComp.streetData[this.keyName].geometry.coordinates[0]
            || this.streetDataComp.streetData[this.keyName].geometry.coordinates[1]) {
           this.updateMap(this.streetDataComp.streetData[this.keyName].geometry.coordinates[1],
             this.streetDataComp.streetData[this.keyName].geometry.coordinates[0], false, true);
         }
         this.streetDataComp.bindStreetData(false);
        }
      }


      this.mapFunc.fitCoords(this.featureCollections.features);
      this.isLoadSavedDocument = false;
      this.cdRef.detectChanges();
    }
  }
  onGetStreetData(streetData: any) {
    this.mapFunc.hasMapDragging = true;

    this.streetDataComp.streetDataStr = JSON.stringify(streetData);

    this.streetDataComp.streetData[this.keyName] = new AddressDetails();
    if (this.mapGeo != null) {
      this.mapGeo.removeFeatures();
    }
    if (streetData == null) {
      return;
    }
    this.streetDataComp.streetData[this.keyName] = streetData;
    this.cdRef.detectChanges();
    this.correctData();
    const lat = streetData.geometry.coordinates[1];
    const lng = streetData.geometry.coordinates[0];
    if (lat && lng) {
      this.updateMap(lat, lng, false, true);
      this.mapFunc.mapObj.zoomToValue(this.searchZoom); // 14479#0053120 ( just use for comp-dev )
    }
    this.resetPostionMandatory();
  }
  correctData() {
    if (this.featureCollections == null) {
        const header = {
            type : 'FeatureCollection',
            features: []
        };
        this.featureCollections = header;
        return;
    }
    const data = this.featureCollections.features[0];
    this.featureCollections.features[0] = new AddressDetails();
    this.sclUtilMapService.streetDataRemoveEmpty(this.featureCollections.features[0]);
    if (!data) { return; }
    let properties: any;
    if (data.properties) {
        const geo = data.geometry;
        if (typeof(geo) !== 'undefined' && geo !== null) {
            geo.type = MapDrawType.POINT;
            data.geometry = geo;

        }
        if (data.geometry && data.geometry.coordinates && data.geometry.coordinates.length === 0) {
            delete data.geometry;
        }
        if (data.geometry) {
            if (!data.geometry.coordinates[0] || isNaN(data.geometry.coordinates[0]) || isNaN(data.geometry.coordinates[1])) {
              delete data.geometry;
            }
        }

        properties = data.properties;
        // properties.country = "";
        // properties.iconImage = "";
        // properties.iconSize = "";
        properties.type = MapSelectAssetType.STREET;
        data.properties = properties;

        data.type = FEATURE_TYPE.FEATURE;
        this.sclUtilMapService.streetDataRemoveEmpty(data);
        this.featureCollections.features[0] = data;

    }

  }
  onRemoveStreetCb() {
    if (this.disabled) { return; }
    const fea = this.mapFunc.mapObj.getFeatureById(this.mapFunc.addressId);
    if (fea) {
      this.removeStreet();
    }
    this.streetDataComp.streetDataStr = null;
  }
  removeStreet() {
    const fea = this.mapFunc.mapObj.getFeatureById(this.mapFunc.addressId);

    this.mapFunc.mapObj.removeLocation(fea);
    this.resetAddressData();

  }
  resetAddressData() {
    if (!this.streetDataComp) {
      return;
    }
    if (!this.streetDataComp.streetData) {
      this.streetDataComp.streetData = {};
      this.streetDataComp.streetData[this.keyName] = new AddressDetails();
      this.addData();
    }
    this.streetDataComp.streetData[this.keyName].properties.unitNo = '';
    this.streetDataComp.streetData[this.keyName].properties.streetNo = '';
    this.streetDataComp.streetData[this.keyName].properties.street = '';
    this.streetDataComp.streetData[this.keyName].properties.suburb = '';
    this.streetDataComp.streetData[this.keyName].properties.state = '';
    this.streetDataComp.streetData[this.keyName].properties.country = '';
    this.streetDataComp.streetData[this.keyName].properties.postcode = '';
    this.streetDataComp.streetData[this.keyName].properties.locationDescription = '';

    if (this.streetDataComp.streetData[this.keyName].geometry) {
      const geometry = {
        type: MapDrawType.POINT,
        coordinates: []
      };
      this.streetDataComp.streetData[this.keyName].geometry = geometry;
    }
    this.streetDataComp.bindStreetData(false);
  }
  addData() {
    if (!this.streetDataComp) {
      return;
    }
    const fullVal = new AddressDetails();
    this.streetDataComp.streetData[this.keyName] = fullVal;
  }
  watchDoc(newValue) {
    if (!newValue || !this.mapFunc || !this.mapFunc.mapObj) {
      return;
    }

    this.featureCollections = this.sclUtilMapService.checkScopeValue(this.featureCollections, MapSelectAssetType.STREET);
    newValue = this.sclUtilMapService.checkScopeValue(newValue, MapSelectAssetType.STREET);

    if (!isEqual(this.featureCollections, newValue)) {
      const value = cloneDeep(newValue);
      this.valueChanged(newValue);
      this.featureCollections = value;
      let streetData;

      if (!newValue) {
          this.removeStreet();
          return;
      }

      const length = newValue?.features?.length;

      for (let i = 0; i < length; i++) {
        const asset = cloneDeep(newValue.features[i]);
        if (asset.properties.type === MapSelectAssetType.STREET) {
          if (typeof(asset.geometry) === 'undefined' || asset.geometry === null || asset.geometry.coordinates.length === 0) {
            continue;
          }
          streetData = asset;
          this.sclUtilMapService.checkStreetGeometryComponent(this.streetDataComp, this.keyName);
          this.resetPostionMandatory();
          this.mapFunc?.geoAutoComplete?.clearStreetSearchTextBox(this.keyName);
          this.updateMap(asset.geometry.coordinates[1], asset.geometry.coordinates[0]
            , false, true);
        }
      }

      const previouseStreetData = (this.streetDataComp ? this.streetDataComp.streetData[this.keyName] : null);

      if (streetData && !isEqual(previouseStreetData, streetData)) {
        if (!this.streetDataComp) {
          this.hasOnFieldValueChange = true;
          this.streetDataInit = streetData;
        } else {
          this.streetDataComp.streetDataStr = JSON.stringify(streetData);
        }
      }
    }
  }
  valueChanged(value) {
    if (value && value.features && value.features.length == 0) {
      value = null;
    }
    if (!isEqual(this.fieldValue, value)) {

      super.valueChanged(value);
      console.log('valueChanged finish');
    }
  }
  
  // //0011229:Watch function trigger updateSize  if map image is not displayed when visible=false.
  watchVisible(newValue, oldValue) {
    // 11942#c40375: specified to 'tplItem.visible' watch function for show/hide of rules
    if (!isEqual(oldValue, newValue)) {
        if (newValue) {
            $('#divAddress' + this.keyName).removeClass('ng-hide');
            this.mapFunc.mapObj.updateSize();
        }
    }
  }



  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
      tooltip.toggle();
  }



  resetPostionMandatory() {
    if (this.positionMandatory && this.streetDataComp) {
      this.streetDataComp.disableMandatory = false;
      this.cdRef.detectChanges();
    }
  }
  setInteract() {
    if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      this.mapFunc.mapObj.selectInteraction();
    }
  }

  selectAssetPopup() {

  }

  getHTMLClusterMarkers(features) {
    if (features === undefined || features.length === 0) {
      return;
    }

    this.clusterList = [];
    const isDisplayOnly = true;
    let currentAssets;
    // if (this.isPrimaryAsset) {
    //   currentAssets = this.assets.primary;
    // } else if (this.isSecondaryAsset) {
    //   currentAssets = this.assets.secondary;
    // }
    for (let i = 0; i < features.length; i++) {
      const feature = features[i];
      const properties = this.mapFunc.mapObj.getFeatureProperties(feature, ['name', 'id', 'layerDisplayOnly', 'url']);
      const name = properties.name;
      const docId = properties.id;
      const exist = this.mapFunc.isContainFeature(docId, currentAssets);
      let check = '';
      if (exist) {
        check = 'checked';
      }
      const id = this.keyName + i + 'cluster';
      const cbName = this.keyName + 'cluster';
      let html = '';
      // if (this.isPrimaryAsset) {
      //   if (!properties.layerDisplayOnly) {
      //     isDisplayOnly = false;
      //     if (this.singlePrimaryAssetSelection) {
      //       html += '<input type=\'radio\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
      //     } else {
      //       html += '<input type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>'; }
      //   }
      //   html += name;
      // } else if (this.isSecondaryAsset) {
      //   if (!properties.layerDisplayOnly) {
      //     isDisplayOnly = false;
      //     if (this.singleSecondaryAssetSelection) {
      //       html += '<input type=\'radio\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
      //     } else {
      //       html += '<input type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
      //     }
      //   }
      //   html += name;
      // } else {
      //   html += '<span id =  \'' + docId + '\'>' + name + '</span>';
      // }
      html += '<span id =  \'' + docId + '\'>' + name + '</span>';

      this.allowSelectAsset = isDisplayOnly;

      this.clusterList.push(html);
    }


    this.mapFunc.showPopupClusters();
    this.cdRef.detectChanges();
  }
  closeClusterPopup(isMultiMode) {
    if (isMultiMode) {
      const id = this.keyName + 'cluster';
      const assets = []; const selectedFeatures = [];
      const selectedAssetIds = [];
      const unSelectedAssetIds = [];
      const assetsCoord = [];
      const coor = this.mapFunc.mapObj.getLatLngFromPixel(this.mapFunc.pixelPopup);
      let street = null;
      let feaType = MapDrawType.LINE_STRING;

      const cboxes = document.getElementsByName(id);
      const len = cboxes.length;
      for (let i = 0; i < len; i++) {
        const iCb = cboxes[i] as HTMLInputElement;
        if (iCb.checked) {
          selectedAssetIds.push(iCb.value);
        } else {
          unSelectedAssetIds.push(iCb.value);
        }
      }
      for (let i = 0; i < selectedAssetIds.length; i++) {
        const fea = this.mapFunc.mapObj.getFeatureById(selectedAssetIds[i]);
        if (fea) {
          const pro = this.mapFunc.mapObj.getFeatureProperties(fea, ['street', 'type', 'coorData']);
          street = pro.street;
          feaType = pro.type;
          if (feaType === MapDrawType.POINT) {
            const loc = pro.coorData;
            assetsCoord.push(loc) ;
          } else {
            assetsCoord.push(coor);
          }
        }
      }
      // const options = { clickFeature: selectedFeatures, pixel: null, isClickMap: false };

      // if (this.isPrimaryAsset) {
      //   this.selectPrimaryAction(assets, unSelectedAssetIds, assetsCoord, this.singlePrimaryAssetSelection, street, options);
      // } else if (this.isSecondaryAsset) {
      //   this.selectSecondaryAction(assets, unSelectedAssetIds, assetsCoord, this.singleSecondaryAssetSelection, street, options);
      // }
      this.clusterList = []; // reset
    }
    this.isPopupClusterOpen = false;
    this.mapFunc.infoClusterPosition = {left: '0px', top: '0px'};
    this.cdRef.detectChanges();
  }

  loadAsset(fromSource, isFirstLoad) {
    this.mapFunc.loadAsset(fromSource, isFirstLoad, {});

  }

  createFeature(params) {
    const featureData = params.featureData;
    const type = params.type;
    const imageFileNo = params.imageFileNo;
    const name = params.name;
    const id = params.id;
    const color = params.color;
    const layerDisplayOnly = params.layerDisplayOnly;
    const anchor = params.anchor;
    // url
    const layerClone = params.layerClone;
    const tooltip = params.tooltip;
    const label = params.label;
    const layer = params.layer;
    const layerIndex = params.layerIndex;
    const centerPoint = params.centerPoint;
    const rotation = params.rotation;
    const scale = params.scale;
    // docId
    const radius = params.radius;
    const circleCenter = params.circleCenter;
    const handlebarsContext = params.handlebarsContext;
    const itemData = params.itemData;
    const primaryMultiPopup = params.primaryMultiPopup;
    const secondaryMultiPopup = params.secondaryMultiPopup;
    const asset = params.asset;



    const feature = this.mapFunc.mapObj.createFeatureByType(featureData.geometry.coordinates, type
      , {
          EPSG: this.mapFunc.EPSG,
          imageFileNo,
          name,
          id,
          color,
          layerDisplayOnly,
          anchor,
          url: null,
          layer: cloneDeep(layerClone),
          primaryMultiPopup,
          secondaryMultiPopup,
          label,
          layerType: layer.type,
          layerIndex,
          centerPoint,
          rotation,
          scale,
          radius,
          circleCenter
        });
    if (feature === null) {
      return null;
    }

    this.mapFunc.mapObj.setFeatureProperties(feature, {
      type: type, coorData: featureData.geometry.coordinates, itemData
    });
    const fea = this.mapFunc.mapObj.getFeatureById(id);
    if (!fea) {
      this.mapFunc.mapObj.addFeature(feature, layerIndex);
      let hbObject;
      hbObject = {};
      hbObject.id = this.mapFunc.mapObj.getFeatureId(feature);
      hbObject.tooltips = layer.tooltips;
      hbObject.layerIndex = layerIndex;
      if (tooltip) { hbObject.tooltips = tooltip; }
      hbObject.handlebarsContext = handlebarsContext;
      hbObject.contextParams = this.mapFunc.contextParams;
      if (!find(this.mapFunc.tooltipHandleBarObjects, { id, layerIndex })) {
        this.mapFunc.tooltipHandleBarObjects.push(hbObject);
      }


      if (this.layersRedraw === true) {
          if (layerIndex in this.mapFunc.mapObj.assetOfLayers) {
            this.mapFunc.mapObj.assetOfLayers[layerIndex].push(feature);
          } else {
            this.mapFunc.mapObj.assetOfLayers[layerIndex] = [feature];
          }
      }
    }

    return feature;
  }

  // street-data events
  onStreetDataComponentInit(e) {
    this.streetDataComp = e.streetDataComp;
    if (this.positionMandatory) {
      this.streetDataComp.disableMandatory = true;
      this.streetDataComp.disableCoordinate = true;
      this.cdRef.detectChanges();
    }
    if (this.hasOnFieldValueChange) {
      this.streetDataComp.streetDataStr = JSON.stringify(this.streetDataInit);
      this.hasOnFieldValueChange = false; // reset
      this.streetDataInit = null; // reset
    }
  }
  onSetStreetDataStr() {
    this.addHeader();
    this.updateValue();
    if (!this.isLoadSavedDocument) {
      const json = cloneDeep(this.featureCollections);
      this.valueChanged(json);
    }
    this.streetDataComp.bindStreetData(false);
  }
  onPropertyValueChange() {

  }
  onValueChangedAddress() {
    this.setDocDirty();
  }
  onCoordinateValueChange() {
    this.correctData();
    this.setDocDirty();
  }

  onMapClickEvent(evt) {
    if (!this.isEditable) { return; }
    if (this.isEditable) {

      const lat = evt.latLng.lat;
      const lng = evt.latLng.lng;
      const coor = [lng, lat];

      this.addData(); // reset this.streetData
      let st: any = new AddressDetails();
      st.geometry.coordinates[0] = lng;
      st.geometry.coordinates[1] = lat;
      if (this.streetDataComp) {
        this.streetDataComp.streetData[this.keyName] = new AddressDetails();
        this.streetDataComp.streetData[this.keyName].geometry.coordinates[0] = lng;
        this.streetDataComp.streetData[this.keyName].geometry.coordinates[1] = lat;
        this.streetDataComp.streetDataStr = JSON.stringify(st);
      }
      this.updateMap(lat, lng, true, this.centerOnReverse); // 14288
      this.mapFunc.mapObj.zoomToValue(this.searchZoom); // 14479#0053120 ( just use for comp-dev )

      this.mapGeo.reverse( [lng, lat], 
        this.onMapClickReverseCb.bind(this, st, lng, lat)
      , this.onMapClickReverseErrorCb.bind(this));
    }
  }

  onMapClickReverseCb(st, lng, lat, streetData) {
    this.mapFunc.hasMapDragging = true;
    this.mapFunc.subLabelTiming = 'Get-Street-Data-By-Click-To-Map';
    if (streetData == null) { return; }
    st = streetData;
    if (this.streetDataComp) {
      this.streetDataComp.streetData[this.keyName] = streetData;
      this.streetDataComp.streetDataStr = JSON.stringify(st);
    }
    this.correctData();
    if (lat != null && lng != null) {
      this.updateMap(lat, lng, true, this.centerOnReverse); // 14288
    }
    this.setDocDirty();
    this.mapFunc.mapObj.zoomToValue(this.searchZoom); // 14479#0053120 ( just use for comp-dev )
    this.resetPostionMandatory();
  }

  onMapClickReverseErrorCb(err) {
    console.log('error = ' + err);
    this.notificationService.error(err);
  }
}
